import type { JsonObject } from './json';

export const isRecord = (value: unknown): value is JsonObject =>
	typeof value === 'object' &&
	value !== null &&
	!Array.isArray(value) &&
	Reflect.ownKeys(value).every((key) => typeof key === 'string');

export const isNonEmptyString = (value: unknown): value is string =>
	typeof value === 'string' && value.trim().length > 0;

export const isValidTimestamp = (value: unknown): value is number =>
	typeof value === 'number' && Number.isFinite(value) && value >= 0;
